import React, { useState } from 'react';
import { renderIcon, DefaultCampaignIcon } from '../../utils/renderIcon';
import './styles.css';

/**
 * CampaignLegend Component
 * 
 * Displays a compact legend showing which color corresponds to which campaign
 * when viewing a saved view with multiple campaigns.
 * 
 * Designed as a tab that attaches to the top of the minimap.
 * Uses CSS transitions for smooth expand/collapse animation.
 */
const CampaignLegend = ({ 
  campaigns = [], 
  viewName = '',
  isVisible = true,
  onCampaignClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isVisible || campaigns.length === 0) {
    return null;
  }

  return (
    <div className={`campaign-legend ${isExpanded ? 'campaign-legend--expanded' : ''}`}>
      {/* Header - always visible, clickable to toggle */}
      <button 
        className="campaign-legend__header"
        onClick={() => setIsExpanded(!isExpanded)}
        title={isExpanded ? "Collapse" : "Show campaign colors"}
      >
        <span className="campaign-legend__title">Campaigns</span>
        <span className="campaign-legend__dots">
          {campaigns.map(campaign => (
            <span 
              key={campaign.id}
              className="campaign-legend__dot"
              style={{ backgroundColor: campaign.color }}
            />
          ))}
        </span>
        <svg 
          className={`campaign-legend__chevron ${isExpanded ? 'campaign-legend__chevron--open' : ''}`}
          width="10" 
          height="10" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {/* Expandable list */}
      <div className={`campaign-legend__list ${isExpanded ? '' : 'campaign-legend__list--collapsed'}`}>
        {campaigns.map(campaign => (
          <button 
            key={campaign.id} 
            className="campaign-legend__item"
            onClick={() => onCampaignClick?.(campaign.id)}
            title={`Pan to ${campaign.name}`}
          >
            <span 
              className="campaign-legend__color"
              style={{ backgroundColor: campaign.color }}
            />
            <span className="campaign-legend__icon">
              {renderIcon(campaign.icon, { size: '11px', fallback: <DefaultCampaignIcon size={11} /> })}
            </span>
            <span className="campaign-legend__name">{campaign.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CampaignLegend;
